import { apiClient } from '_app'
import { ApiResponse } from 'dtos'
import {
  NeedsToBeMovedToStagingDto,
  NeedsToBeMovedToStagingQueryParams,
  NeedsToBeMovedToStagingVehicleDetailDto,
  NeedsToBeMovedToStagingVehicleInfoDto
} from 'dtos/toDoLists/outboundTrips'
import { objectToFormData, URIQuery } from 'utils'

const baseUrl = (): string => `/api/to-do-lists/outbound-trips/needs-to-be-moved-to-staging`
const guidUrl = (vehicleGuid: string): string => `${baseUrl()}/${encodeURIComponent(vehicleGuid)}`

export const getNeedsToBeMovedToStagingToDoList = (queryParams: NeedsToBeMovedToStagingQueryParams) =>
  apiClient.get<ApiResponse<NeedsToBeMovedToStagingDto[]>>(baseUrl() + URIQuery(queryParams)).then(res => res.data)

export const getVehicleInfo = (vehicleGuid: string) =>
  apiClient.get<ApiResponse<NeedsToBeMovedToStagingVehicleInfoDto>>(guidUrl(vehicleGuid)).then(res => res.data)

export const getVehicleDetail = (vehicleGuid: string, search: string) =>
  apiClient.get<ApiResponse<NeedsToBeMovedToStagingVehicleDetailDto>>(`${guidUrl(vehicleGuid)}/search` + URIQuery({ search })).then(res => res.data)

export const moveToStaging = (data: NeedsToBeMovedToStagingVehicleDetailDto) =>
  apiClient<undefined>({
    data: objectToFormData(data),
    headers: { 'Content-Type': 'multipart/form-data' },
    method: 'post',
    url: baseUrl()
  }).then(res => res.data)
